import { Link } from "react-router-dom";
import type { CastItem } from "@/types/film";

export default function CastCard({ item }: { item: CastItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-72 w-full overflow-hidden bg-background-100">
        <img
          src={item.image}
          alt={item.name}
          title={`${item.name} 饰 ${item.character} 蜜桃成熟时3D 演员阵容`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
          {item.roleType}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">{item.name}</h3>
        <p className="mt-1 text-sm text-foreground-500">饰 {item.character}</p>
        <span className="mt-3 flex items-center gap-1 text-sm font-medium text-accent-600">
          查看资料
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}